package com.yendo.mx.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore // 🚀 CAMBIO: Importamos Firestore
import com.yendo.mx.models.RestauranteFirebase
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.catch

object RestauranteRepository {
    // 🚀 Cambiamos .database por .firestore
    private val db = Firebase.firestore

    fun obtenerRestaurantes(): Flow<List<RestauranteFirebase>> {
        // En Firestore, apuntamos a la colección maestra "Negocios"
        return db.collection("Negocios")
            .where {
                all(
                    "operacion.visible" equalTo true,
                    "operacion.activo_comercio" equalTo true
                )
            } // 🚀 ADUANA DUAL: Solo locales visibles para el cliente
            .snapshots // 🚀 Esto nos da actualizaciones en tiempo real (como valueEvents)
            .map { querySnapshot ->
                querySnapshot.documents.map { doc ->
                    try {
                        // 🚀 La magia: doc.data<T>() mapea todo automáticamente
                        // gracias a los @Serializable y @SerialName que pusimos.
                        val restaurante = doc.data<RestauranteFirebase>()

                        // Le inyectamos el ID del documento para que no se pierda
                        restaurante.copy(id = doc.id)
                    } catch (e: Exception) {
                        println("🚨 ERROR MAPEANDO DOCUMENTO ${doc.id}: ${e.message}")
                        RestauranteFirebase() // Devolvemos uno vacío si falla
                    }
                }
            }
            .catch { error ->
                println("🚨 ERROR EN REPOSITORIO FIRESTORE: ${error.message}")
                emit(emptyList())
            }
    }
}